import { render, staticRenderFns } from "./com-order-search.vue?vue&type=template&id=c01cef5e&"
import script from "./com-order-search.vue?vue&type=script&lang=js&"
export * from "./com-order-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports